import { render, staticRenderFns } from "./SubscriptionElement.vue?vue&type=template&id=b1485058&scoped=true&"
import script from "./SubscriptionElement.vue?vue&type=script&lang=js&"
export * from "./SubscriptionElement.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionElement.vue?vue&type=style&index=0&id=b1485058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1485058",
  null
  
)

export default component.exports